// to do
// code can be optimized

import { Injectable } from '@angular/core';
import { StageService } from './stage.service';
import { SizeHelperService } from './size-helper.service';
import { ComponentBase } from '../component-base';
import { AppStateService } from './app-state.service';
import { Select3dService } from './select-3d.service';
import { AutoScaleSprite } from '../custom/AutoScaleSprite';
import { StairsDimensionService } from './stairs-dimension.service';
import { CameraService } from './camera.service';
import { AppSettingsService } from './app-settings.service';
import { BehaviorSubject, Observable } from 'rxjs';
declare var THREE: any;

@Injectable()
export class ImageUtilsService extends ComponentBase {
  public isShowDimensionsSubject: BehaviorSubject<boolean>;
  public isShowDimensionsObservable: Observable<boolean>;

  constructor(
    private stage: StageService,
    private sizeHelper: SizeHelperService,
    private appStateService: AppStateService,
    private select3dService: Select3dService,
    private stairsDimensionService: StairsDimensionService,
    private cameraService: CameraService,
    private appSettingsService: AppSettingsService
  ) {
    super();
    this.disable();
    this.isShowDimensionsSubject = new BehaviorSubject<boolean>(true);
    this.isShowDimensionsObservable = this.isShowDimensionsSubject.asObservable();
    this.select3dService.selectedTierSubject.subscribe(value => {
      if (this.isEnabled() && this.isShowDimensionsValue) {
        this.drawTextSprites();
      }
    });
    this.stairsDimensionService.dimensionConditionChange.subscribe(condition => {
      if (condition) {
        this.checkIntersectionWithStairDimencions()
      }
    })
  }

  sprites = [];
  spritesForSnapShot = [];
  rayCaster = new THREE.Raycaster();

  public get isShowDimensionsValue(): boolean {
    return this.isShowDimensionsSubject.value;
}

  drawTextSprites(points?, edges?) {
    let needNewSprites = false;
    let floor = this.select3dService.getSelectedTier();
    var counter = 0;
    var points = points || floor.userData.points;
    var edges = edges || floor.userData.edges;
    var height = floor.getWorldPosition(new THREE.Vector3()).y;
    if (!(this.sprites[0] && this.sprites[0].userData.floorId === floor.id)) {
      this.sprites.length && this.removeSprites();
      needNewSprites = true;
    }
    for (var i = 0; i < points.length; i++) {
      let sideLength: any,
        scaleX;
      if (this.appStateService.sizeUnits === 'imperial') {
        sideLength = this.sizeHelper.CMToFTAndINCHToEdge(edges[i].length);
        sideLength = sideLength.replace('\'', '\' ');

        scaleX = 100;
      } else {
        sideLength = parseFloat(edges[i].length.toFixed(0));
        scaleX = 100;
      }
      if (needNewSprites) {
        var sprite = this.textSprite(sideLength,
          { fontsize: 24,
            borderColor: { r: 255, g: 0, b: 0, a: 1.0 },
            backgroundColor: { r: 255, g: 100, b: 100, a: 0.8 } });
        sprite.userData.point = points[i];
        sprite.userData.floorId = floor.id;
        sprite.visible = true;
        // sprite.name

        this.sprites.push(sprite);
      } else {
        let can = this.newMapForSprites(sideLength,
          { fontsize: 24,
            borderColor: { r: 255, g: 0, b: 0, a: 1.0 },
            backgroundColor: { r: 255, g: 100, b: 100, a: 0.8 } });
        this.sprites[counter].updateMat(can);
      }

      let AB = new THREE.Vector3(points[(i + 1) % points.length].x - points[i].x, 0, points[(i + 1) % points.length].y - points[i].y);
      let vect = new THREE.Vector3(AB.z, 0, -AB.x);
      let norm = vect.normalize();
      norm.setLength(50);

      if (!needNewSprites) {
        THREE.SceneUtils.detach(this.sprites[counter], floor, this.stage.getScene());
      }
      this.sprites[counter].position.set((points[i].x + points[(i + 1) % points.length].x) / 2, (height), (points[i].y + points[(i + 1) % points.length].y) / 2);
      this.sprites[counter].position.add(norm);
      if (this.isShowDimensionsValue) {
        this.stage.add(this.sprites[counter]);
        THREE.SceneUtils.attach(this.sprites[counter], this.stage.getScene(), floor);
      }
      counter++;
    }
  }

  drawTextSpritesForPdfSnapShot(floor) {
    let counter = 0;
    const sprites = [];
    const points = floor.userData.points;
    const edges = floor.userData.edges;
    const height = floor.getWorldPosition(new THREE.Vector3()).y;
    for (let i = 0; i < points.length; i++) {
      let sideLength: any,
        scaleX;
      if (this.appStateService.sizeUnits === 'imperial') {
        sideLength = this.sizeHelper.CMToFTAndINCHToEdge(edges[i].length);
        sideLength = sideLength.replace('\'', '\' ');

        scaleX = 100;
      } else {
        sideLength = parseFloat(edges[i].length.toFixed(0));
        scaleX = 100;
      }
      // if (needNewSprites) {
        const sprite = this.textSprite(sideLength,
          { fontsize: 24,
            borderColor: { r: 255, g: 0, b: 0, a: 1.0 },
            backgroundColor: { r: 255, g: 100, b: 100, a: 0.8 } });
        sprite.userData.point = points[i];
        sprite.userData.floorId = floor.id;
        sprite.visible = true;
        // sprite.name

      sprites.push(sprite);
      // } else {
      //   let can = this.newMapForSprites(sideLength,
      //     { fontsize: 24,
      //       borderColor: { r: 255, g: 0, b: 0, a: 1.0 },
      //       backgroundColor: { r: 255, g: 100, b: 100, a: 0.8 } });
      //   this.sprites[counter].updateMat(can);
      // }

      const AB = new THREE.Vector3(points[(i + 1) % points.length].x - points[i].x, 0, points[(i + 1) % points.length].y - points[i].y);
      const vect = new THREE.Vector3(AB.z, 0, -AB.x);
      const norm = vect.normalize();
      norm.setLength(50);

      // if (!needNewSprites) {
      //   THREE.SceneUtils.detach(this.sprites[counter], floor, this.stage.getScene());
      // }
      sprites[counter].position.set((points[i].x + points[(i + 1) % points.length].x) / 2, (height), (points[i].y + points[(i + 1) % points.length].y) / 2);
      sprites[counter].position.add(norm);
      // if (this.isShowDimensionsValue) {
        this.stage.add(sprites[counter]);
        // THREE.SceneUtils.attach(this.sprites[counter], this.stage.getScene(), floor);
      // }
      counter++;
    }
  }

  newMapForSprites(text, params) {
    var font = "LatoWebLight",
      size = 35,
      color = "white";

    font = "bold " + size + "px " + font;
    var canvas = document.createElement('canvas');
    var context = canvas.getContext('2d');
    context.font = font;

    // get size data (height depends on font size)
    var metrics = context.measureText(text),
      textWidth = metrics.width;

    canvas.width = textWidth + 30;
    canvas.height = 64;
    context.fillStyle = "grey";

    // round corners
    context.beginPath();
    context.moveTo(canvas.width, 64);
    context.arcTo(0, 64, 0, 0, 32);
    context.arcTo(0, 0, canvas.width, 0, 32);
    context.arcTo(canvas.width, 0, canvas.width, 64, 32);
    context.arcTo(canvas.width, 64, 0, 64, 32);
    context.fill();

    context.font = font;
    context.fillStyle = color;
    context.textAlign = "right";
    context.fillText(text, textWidth + 15, size + 6);

    return canvas;
  }

  textSpriteForPdfSnapShot(text, params) {
    var font = "LatoWebLight",
      size = params.fontsize,
      color = "white";

    font = "bold " + size + "px " + font;
    var canvas = document.createElement('canvas');
    var context = canvas.getContext('2d');
    context.font = font;

    // get size data (height depends on font size)
    var metrics = context.measureText(text),
      textWidth = metrics.width;

    canvas.width = textWidth + 15;
    canvas.height = 24;
    context.fillStyle = 'grey';

    // round corners
    context.beginPath();
    context.moveTo(canvas.width, canvas.height);
    context.arcTo(0, canvas.height, 0, 0, canvas.height / 2);
    context.arcTo(0, 0, canvas.width, 0, canvas.height / 2);
    context.arcTo(canvas.width, 0, canvas.width, canvas.height, canvas.height / 2);
    context.arcTo(canvas.width, canvas.height, 0, canvas.height, canvas.height / 2);
    context.fill();

    context.font = font;
    context.fillStyle = color;
    context.textAlign = 'right';
    context.fillText(text, textWidth + 8, size + 3);

    // canvas contents will be used for a texture
    var texture = new THREE.CanvasTexture(canvas);

    var spriteMaterial = new THREE.SpriteMaterial({ map: texture, depthTest: false });
    var sprite = new AutoScaleSprite(canvas.width * 5 / 8, 22, spriteMaterial);
    return sprite;
  }

  textSprite(text, params) {
    var font = "LatoWebLight",
      size = 35,
      color = "white";

    font = "bold " + size + "px " + font;
    var canvas = document.createElement('canvas');
    var context = canvas.getContext('2d');
    context.font = font;

    // get size data (height depends on font size)
    var metrics = context.measureText(text),
      textWidth = metrics.width;

    canvas.width = textWidth + 30;
    canvas.height = 64;
    context.fillStyle = "grey";

    // round corners
    context.beginPath();
    context.moveTo(canvas.width, 64);
    context.arcTo(0, 64, 0, 0, 32);
    context.arcTo(0, 0, canvas.width, 0, 32);
    context.arcTo(canvas.width, 0, canvas.width, 64, 32);
    context.arcTo(canvas.width, 64, 0, 64, 32);
    context.fill();

    context.font = font;
    context.fillStyle = color;
    context.textAlign = "right";
    context.fillText(text, textWidth + 15, size + 6);

    // canvas contents will be used for a texture
    var texture = new THREE.CanvasTexture(canvas);

    var spriteMaterial = new THREE.SpriteMaterial({ map: texture, depthTest: false });
    var sprite = new AutoScaleSprite(canvas.width * 5 / 8, 40, spriteMaterial);
    return sprite;
  }

  hideSprites() {
    for (let i = 0; i < this.sprites.length; i++) {
      const sprite = this.sprites[i];
      if (sprite.parent) {
        sprite.parent.remove(sprite);
      }
    }
    this.sprites = [];
    // this.stage.removeMany(this.sprites);
    this.isShowDimensionsSubject.next(false);
  }

  showSprites() {
    // suppressed e.g. on the DockRail railing step (anchor/arrow icons own the edges)
    if (!this.isEnabled()) {
      return;
    }
    // this.stage.addMany(this.sprites);
    if (this.select3dService.getSelectedTier()) {
      this.isShowDimensionsSubject.next(true);
      this.drawTextSprites();
    }
  }

  removeSprites() {
    // this.stage.removeMany(this.sprites);
    for (let i = 0; i < this.sprites.length; i++) {
      const sprite = this.sprites[i];
      if (sprite.parent) {
        sprite.parent.remove(sprite);
      }
    }
    this.sprites = [];
  }

  mouseMove(e) {
    this.checkIntersectionWithStairDimencions()
  }

  checkIntersectionWithStairDimencions() {
    this.sprites.forEach(sprite => {
      if (!sprite.visible) {
        sprite.visible = true;
      }
    });
    if (this.stairsDimensionService.getCentrPosition()) {

      let direction = this.stairsDimensionService.getCentrPosition();
      if (this.appSettingsService.is2D) {
        let delta = new THREE.Vector3(0, 30, 0);
        delta.add(direction);
        this.rayCaster.set(direction, delta);
      } else {
        this.rayCaster.set(direction, this.cameraService.camera.position);
      }
      this.rayCaster.set(direction, this.cameraService.camera.position);
      let intersection = this.rayCaster.intersectObjects(this.sprites);
      if (intersection.length) {
        intersection.forEach(el => {
          el.object.visible = false;
        });
      } else {
        this.sprites.forEach(sprite => {
          if (!sprite.visible) {
            sprite.visible = true;
          }
        });
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/services/image-utils.service.ts